import React from 'react';
export const links = [
  {
    id: 1,
    to: 'home',
    text: 'home',
  },
  {
    id: 2,
    to: 'about',
    text: 'about',
  },
  {
    id: 3,
    to: 'ressume',
    text: 'resume',
  },
  {
    id: 4,
    to: 'contact',
    text: 'contact',
  },

];
